@if (rights?.includes('PP')) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch Case to Client Information"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete:
        dataItem.ciStatus === 'C' ||
        ((dataItem.ciStatus === '' || !dataItem.ciStatus) &&
          dataItem.ppStatus === 'C'),
      opened:
        dataItem.ciStatus === 'O' ||
        ((dataItem.ciStatus === '' || !dataItem.ciStatus) &&
          dataItem.ppStatus === 'O'),
    }"
    [disabled]="rights?.includes('DisableCaseLaunchButtons')"
    (click)="
      launchApp($event, dataItem.profileId, 'rb'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon">perm_contact_calendar</mat-icon>
  </button>
}
@if (rights?.includes('PP')) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch Case in Product Profiler"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete: dataItem.ppStatus === 'C',
      opened: dataItem.ppStatus === 'O',
    }"
    [disabled]="
      (dataItem.ppStatus !== 'C' && dataItem.ppStatus !== 'O') ||
      rights?.includes('DisableCaseLaunchButtons')
    "
    (click)="
      launchApp($event, dataItem.profileId, 'pp'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon" svgIcon="pp_icon" />
  </button>
}
@if (rights?.includes('AW')) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch Case in Annuity Wizard"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete: dataItem.awStatus === 'C',
      opened: dataItem.awStatus === 'O',
    }"
    [disabled]="
      (dataItem.awStatus !== 'C' && dataItem.awStatus !== 'O') ||
      rights?.includes('DisableCaseLaunchButtons')
    "
    (click)="
      launchApp($event, dataItem.profileId, 'aw'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon" svgIcon="aw_icon" />
  </button>
}
@if (rights?.includes('IW')) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch Case in Investment Wizard"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete: dataItem.iwStatus === 'C',
      opened: dataItem.iwStatus === 'O',
    }"
    [disabled]="
      (dataItem.iwStatus !== 'C' && dataItem.iwStatus !== 'O') ||
      rights?.includes('DisableCaseLaunchButtons')
    "
    (click)="
      launchApp($event, dataItem.profileId, 'iw'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon" svgIcon="iw_icon" />
  </button>
}
@if (rights?.includes('LI')) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch Case in Life Insurance Wizard"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete: dataItem.lwStatus === 'C',
      opened: dataItem.lwStatus === 'O',
      disabled: dataItem.lwStatus !== 'O' && dataItem.lwStatus !== 'C',
    }"
    [disabled]="
      (dataItem.lwStatus !== 'C' && dataItem.lwStatus !== 'O') ||
      rights?.includes('DisableCaseLaunchButtons')
    "
    (click)="
      launchApp($event, dataItem.profileId, 'li'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon" svgIcon="lw_icon" />
  </button>
}
@if (showSummaryLink) {
  <button
    type="button"
    mat-icon-button
    matTooltip="Launch to Case Summary"
    class="app-button"
    [matTooltipShowDelay]="1000"
    [ngClass]="{
      complete:
        dataItem.lwStatus === 'C' ||
        dataItem.iwStatus === 'C' ||
        dataItem.awStatus === 'C' ||
        dataItem.ppStatus === 'C',
    }"
    [disabled]="
      dataItem.lwStatus !== 'C' &&
      dataItem.iwStatus !== 'C' &&
      dataItem.awStatus !== 'C' &&
      dataItem.ppStatus !== 'C'
    "
    (click)="
      launchApp($event, dataItem.profileId, 'summary'); $event.stopPropagation()
    "
  >
    <mat-icon class="app-button-icon">list</mat-icon>
  </button>
}
